import { render, staticRenderFns } from "./adminCard.vue?vue&type=template&id=671afd6e&"
import script from "./adminCard.vue?vue&type=script&lang=js&"
export * from "./adminCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports